import { isFunction, isObject, isString, noop } from 'angular';
var CompareTableComponentController = (function () {
    function CompareTableComponentController(compareTableConfiguration, locationService) {
        var _this = this;
        this.compareTableConfiguration = compareTableConfiguration;
        this.locationService = locationService;
        this.getBackToSearchResultsUrl = function () {
            var devices = (_this.thirdPartyDevices || []).map(function (t) { return t.searchKey; });
            return _this.locationService.build('compatibilityguide/gallery', { thirdPartyProducts: devices });
        };
    }
    CompareTableComponentController.prototype.$onInit = function () {
        var _this = this;
        this.compareTableConfiguration.get().then(function (sections) {
            _this.sections = sections.filter(function (s) { return s.attributes.length > 0; });
        }, noop);
    };
    CompareTableComponentController.prototype.excludeGroup = function (group) {
        if (!isFunction(this.onExcludeGroup)) {
            return;
        }
        this.onExcludeGroup({ group: group });
    };
    CompareTableComponentController.prototype.getSolutionUrl = function (groupKey) {
        var devices = (this.thirdPartyDevices || []).map(function (t) { return t.searchKey; });
        return this.locationService.build('compatibilityguide/solutions', {
            products: [groupKey],
            thirdPartyProducts: devices,
        });
    };
    CompareTableComponentController.prototype.anyPropertyMatching = function (propertyName) {
        return this.groups.every(function (g) { return isString(g[propertyName]) && g[propertyName] !== ''; });
    };
    CompareTableComponentController.prototype.anyAttributeMatching = function (attribute) {
        if (attribute.key === '' || !isObject(attribute.map) || attribute.map === null) {
            return false;
        }
        var matching = false;
        for (var _i = 0, _a = this.groups; _i < _a.length; _i++) {
            var group = _a[_i];
            var _loop_1 = function (mapping) {
                var attributeValue = attribute.key + "|" + mapping;
                matching = matching || group.attributes.some(function (a) { return attributeValue === a; });
            };
            for (var _b = 0, _c = Object.keys(attribute.map); _b < _c.length; _b++) {
                var mapping = _c[_b];
                _loop_1(mapping);
            }
        }
        return matching;
    };
    CompareTableComponentController.prototype.anySectionMatching = function (section) {
        var _this = this;
        return section.attributes.some(function (a) { return _this.anyAttributeMatching(a); });
    };
    CompareTableComponentController.prototype.anySectionsMatching = function () {
        var _this = this;
        if (!Array.isArray(this.sections)) {
            return undefined;
        }
        return this.sections.some(function (section) { return _this.anySectionMatching(section); });
    };
    CompareTableComponentController.$inject = ['compareTableConfiguration', 'locationService'];
    return CompareTableComponentController;
}());
export var CompareTableComponent = {
    bindings: {
        groups: '<',
        onExcludeGroup: '&?',
        thirdPartyDevices: '<',
    },
    controller: CompareTableComponentController,
    templateUrl: 'compatibilityguide/ng-templates/feature/compare/comparetable',
};
